import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Icon, type IconName } from "../icons/Icon";
import { cx } from "../utils/format";
import { Spinner } from "./Spinner";

export type ButtonVariant = "primary" | "secondary" | "outline" | "ghost" | "icon";
/** `busy` (integrations round two, the founder, 2026-10-13): the click waits for the server. The kit's spinner takes the icon's place (hidden
 *  from screen readers: the name stays the label), the button is off (busy wins over a screen's `disabled={false}`) and says `aria-busy`. */
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant; size?: "sm"; icon?: IconName; active?: boolean; busy?: boolean; children?: ReactNode;
}

export function Button({ variant = "secondary", size, icon, active, busy, disabled, className, children, type = "button", ...rest }: ButtonProps) {
  return (
    <button type={type} className={cx("ob-btn", `ob-btn--${variant}`, size && `ob-btn--${size}`, active && "ob-btn--active", busy && "ob-btn--busy", className)}
      disabled={busy || disabled} aria-busy={busy || undefined} {...rest}>
      {busy ? <Spinner decorative /> : icon && <Icon name={icon} size={variant === "icon" ? "md" : "sm"} />}
      {children}
    </button>
  );
}

export function SplitButton({ label, onClick, onMore, variant = "primary" }: { label: string; onClick: () => void; onMore?: () => void; variant?: ButtonVariant }) {
  return (
    <span className="ob-btn-split">
      <Button variant={variant} onClick={onClick}>{label}</Button>
      <Button variant={variant} onClick={onMore} aria-label="More options"><Icon name="chevronDown" size="sm" /></Button>
    </span>
  );
}
